<template lang="pug">
OrderActionModal(:show="show" max-width="min(100vw - 2rem, 40rem)" @close="onClose")
  template(slot="header")
    .notification-history-modal__title Historial de notificaciones
  .notification-history-modal
    .notification-history-modal__order Orden {{ orderCode }}

    .notification-history-modal__empty(v-if="!historyEntries.length")
      | No hay notificaciones registradas para esta orden.

    .notification-history-modal__list(v-if="historyEntries.length")
      .notification-history-modal__entry(
        v-for="(entry, index) in historyEntries"
        :key="index"
        :class="{ 'notification-history-modal__entry--error': entry.error }"
      )
        .notification-history-modal__entry-head
          span.notification-history-modal__platform {{ platformLabel(entry.platform) }}
          span.notification-history-modal__status {{ statusLabel(entry.status) }}
          span.notification-history-modal__date {{ formatDate(entry.createdAt) }}
        .notification-history-modal__error(v-if="entry.error") {{ entry.error }}
</template>

<script>
import OrderActionModal from '@/components/pages/order/refund/OrderActionModal.vue'
import mFilters from '@/mixins/filters'

const PLATFORM_LABELS = {
  email: 'Email',
  sms: 'SMS',
  whatsapp: 'WhatsApp'
}

const STATUS_LABELS = {
  paid: 'Pagado',
  sent: 'Enviado',
  tracking: 'Guía de envío'
}

export default {
  name: 'NotificationHistoryModal',

  components: { OrderActionModal },

  mixins: [mFilters],

  props: {
    show: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: null
    }
  },

  computed: {
    orderCode () {
      return (this.order && this.order.order) || ''
    },

    historyEntries () {
      const notifications = this.order && this.order.notifications
      const history = notifications && notifications.history
      if (!Array.isArray(history)) return []

      return history.slice().sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })
    }
  },

  methods: {
    onClose () {
      this.$emit('close')
    },

    formatDate (value) {
      if (!value) return '—'
      return this.dateName(value) + ' · ' + this.time(value)
    },

    platformLabel (platform) {
      return PLATFORM_LABELS[platform] || platform || '—'
    },

    statusLabel (status) {
      return STATUS_LABELS[status] || status || '—'
    }
  }
}
</script>

<style lang="stylus" scoped>
.notification-history-modal
  padding 0 1.5rem 1.5rem
  overflow-y auto
  max-height calc(100vh - 8rem)

.notification-history-modal__title
  font-weight 600
  font-size 1.1rem

.notification-history-modal__order
  font-size .95rem
  opacity .75
  margin-bottom 1rem

.notification-history-modal__empty
  padding 1rem 0
  opacity .7
  font-size .95rem

.notification-history-modal__entry
  padding .75rem 0
  border-bottom 1px solid rgba(0, 0, 0, .08)

.notification-history-modal__entry--error
  .notification-history-modal__platform
    color #c0392b

.notification-history-modal__entry-head
  display flex
  flex-wrap wrap
  gap .35rem 1rem
  align-items center
  font-size .9rem

.notification-history-modal__platform
  font-weight 600

.notification-history-modal__status
  opacity .85

.notification-history-modal__date
  margin-left auto
  font-size .85rem
  opacity .7

.notification-history-modal__error
  margin-top .4rem
  font-size .85rem
  color #c0392b
  word-break break-word
</style>



// WEBPACK FOOTER //
// src/components/pages/order/NotificationHistoryModal.vue